import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Paper, Typography
} from '@mui/material';

import AbEnvironment from '../auth/AbEnvironment';

import CheckCircle from '@mui/icons-material/CheckCircle';
import PauseCircleFilled from '@mui/icons-material/PauseCircleFilled';
import { green, blue } from '@mui/material/colors';
import { NumericFormat } from 'react-number-format';

import AppLogo from '../ui/AppLogo';
// import PercentageNumberFormat from '../ui/PercentageNumberFormat';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
    paper: {
      [theme.breakpoints.up('xs')]: {
        width: 'calc(100% - 20px)',
      },
      [theme.breakpoints.up('sm')]: {
        width: 380,
      },
      maxWidth: 380,
      height: 48,
      marginTop: theme.spacing(3),
      //overflow: 'auto',
      padding: 20,
      '&:hover': {
          backgroundColor: '#f7f7f7',
          cursor: 'pointer'
      }
    },
    appLogo: {
      float: 'left',
      marginRight: 15
    },
    appDescription: {
      float: 'left',
      maxWidth: 270,
      [theme.breakpoints.up('xs')]: {
        /* subtract width of the other 2 columns + the margins */
        width: 'calc(100% - 48px - 15px - 15px - 24px)',
      },
      [theme.breakpoints.up('sm')]: {
        width: 270,
      },
    },
    appStatus: {
      float: 'right',
      marginTop: 4,
      clear: 'right',
    },
    // not used on this page
    // avatar: {
    //     marginRight: 20,
    //     float: 'left',
    //     backgroundColor: theme.palette.secondary.light,
    //     color: theme.palette.text.secondary
    // },
    appTitle: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    skuName: {
        color: 'inherit'
    },
    markup: {
        color: '#666666'
    }
});

class AppOverview extends Component {

    goTo(url) {
        const sterm = this.props.sterm;
        if (sterm != null)
        {
            localStorage.setItem('appsSterms', sterm);
        }
        this.props.history.push(`${url}`);
    }

    render() {
        const { isAuthenticatedVendor } = this.props.auth;

        const statusOk = green[300];
        const statusInactive = blue[300];
        const app = this.props.app;
        const classes = this.props.classes;

        let theUrl = "./app?appId=" + app.appId;

        let thePerc = app.appMarkupPercentage;

        let mdDescriptor = 'Markup';
        let mdSign = '+';

        if (thePerc < 0) {
            mdDescriptor = 'Discount';
            mdSign = '-';
            thePerc = -1 * thePerc;
        }

        let theTitleLine;
        if (app.appName === app.appSku || app.appSku == null || app.appSku === '') {
            theTitleLine = app.appName;
        } else {
            theTitleLine = app.appName + " (" + app.appSku + ")";
        }

        //for services
        let billingFrequency = '';
        if (app.appType === 1) {
          theUrl = "./serviceedit?appId=" + app.appId;
          if (app.billingFrequency === 0) {
            billingFrequency = "Frequency: one-time";
          } else if (app.billingFrequency === 1) {
            billingFrequency = "Frequency: monthly";
          } else if (app.billingFrequency === 2) {
            billingFrequency = "Frequency: annual";
          }
        }

        return (
            <div>
                <Paper elevation={2} className={classes.paper} onClick={() => {this.goTo(theUrl);}}>
                    <div className={classes.appLogo}>
                        <AppLogo logoPath={app.appLogo} appName={theTitleLine} imageHeight='48px'/>
                    </div>
                    <div className={classes.appDescription} >
                        <Typography className={classes.appTitle} variant="h6">
                            {theTitleLine}
                        </Typography>
                        {app.appType === 0 && (app.paymentOrder === 0 || app.paymentOrder === 1) && (abEnvironment.getUserAttribute('a_aType') !== "1") && (! isAuthenticatedVendor()) &&
                        <Typography variant="caption" className={classes.markup}>
                            {mdDescriptor}:
                            &nbsp;{mdSign}
                            <NumericFormat
                              value={thePerc}
                              valueIsNumericString
                              displayType="text"
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator
                            />
                            %
                        </Typography>}
                        {app.appType === 0 && app.paymentOrder === 2 && (! isAuthenticatedVendor()) &&
                        <Typography variant="caption" className={classes.markup}>Expense to me</Typography>}
                        {app.appType === 0 && app.paymentOrder === 4 && (! isAuthenticatedVendor()) &&
                        <Typography variant="caption" className={classes.markup}>Request access</Typography>}
                        {app.appType === 0 && app.paymentOrder === 5 && (! isAuthenticatedVendor()) &&
                        <Typography variant="caption" className={classes.markup}>I will sign up</Typography>}
                        {app.appType === 1 && (! isAuthenticatedVendor()) &&
                        <Typography variant="caption" className={classes.markup}>{billingFrequency}</Typography>}
                    </div>
                    <div className={classes.appStatus}>
                      { app.appStatus === 0 &&
                      <div>
                        <CheckCircle htmlColor={statusOk}/>
                      </div>
                      }
                      { app.appStatus === 1 &&
                      <div>
                        <PauseCircleFilled htmlColor={statusInactive}/>
                      </div>
                      }
                    </div>
                </Paper>
            </div>
        );
    }
}

export default withStyles(styleSheet)(AppOverview);
